export default {
  contacts: (state) => {
    return state.searchTerm.length > 1 ? state.searchResults : state.contacts;
  },
  // contacts: (state) => {
  //   return state.filterContact.length > 1
  //     ? state.filterContact
  //     : state.contacts;
  // },
  activeChat: (state) => {
    return state.activeChat;
  },
  messages: (state) => {
    return state.messages;
  },
  showChats: (state) => {
    return state.showChats;
  },
  showContacts: (state) => {
    return state.showContacts;
  },
  avatar: (state) => {
    return state.avatar;
  },
  agentMessages: (state) => {
    return state.agentMessages;
  },
};
